import type { Container } from 'pixi.js';

export function getAllDisplayObjectsFrom(root: Container, out: Container[] = [], skipSelf = false): Container[] {
  if (!skipSelf) {
    out.push(root);
  }

  if (root.children) {
    out.push(...root.children);
    root.children.forEach((child) => {
      getAllDisplayObjectsFrom(child, out, true);
    });
  }

  return out;
}
